var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"item-add-wrapper do-not-print"},[_c('a',{staticClass:"product-template-builder-item-add",attrs:{"data-test":"link:product-template-builder-item-add"},on:{"click":_vm.onClick}},[_vm._v(_vm._s(_vm.$tc('forms.add-item', 1)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }